/**
 * @ngdoc directive
 * @name footerpanelreassurance
 *
 * @description
 * Extended footer version : reassurance panel
 */
module.directive('footerpanelreassurance', function () {
    'use strict';
    return {
        restrict: 'E',
        replace: true,
        scope: {
            reassurances: '=content'
        },
        template:
                '<div class="aqua-footerpanel--reassurance">' +
                '  <ul class="aqua-footerpanel--reassurance-items grid grid-gutter">' +
                '    <li class="aqua-footerpanel--reassurance-item grid grid-middle grid-12-s" ng-repeat="reassurance in reassurances">' +
                '      <img class="aqua-footerpanel--reassurance-picture" aqua-src="{{reassurance.picto.url}}" alt="{{reassurance.label}}" />' +
                '      <span class="aqua-footerpanel--reassurance-block">' +
                '        <span class="aqua-footerpanel--reassurance-title">{{reassurance.title}}</span>' +
                '        <span class="aqua-footerpanel--reassurance-text" ng-bind-html="reassurance.text | trustAsHtml"></span>' +
                '      </span>' +
                '    </li>' +
                '  </ul>' +
                '</div>'
    };
});